//REDUCER
import {  RECIEVE_USER_SURVEY, SET_SURVEY_TAKEN, ADD_SURVEY_RESPONSE, ADD_SURVEY_RESPONSE_TEXT, ADD_SURVEY_STARS /*ADD_REVIEW_EXPERIENCE, ADD_REVIEW_TEXT,*/} from '../actions'
import ReactGA from 'react-ga'
import { createAction, createReducer } from '@reduxjs/toolkit'


const initialState = {
	taken: false,
	responses: null,
	is_filled_out: false,
	stars: null
};

const survey = createReducer(initialState, (builder) => {
    builder
	.addCase(createAction(RECIEVE_USER_SURVEY), (state, action) => {
        state.taken = action.json.user.survey.taken
	})
	.addCase(createAction(ADD_SURVEY_RESPONSE), (state, action) => {
        if(state.responses == null)
		  {
			  state.responses = [];
			  let i;
			  for (i = 0; i < 7; i++) //TODO make 7 dynamic
			  { 
				  state.responses.push({question: "", response: "", comment: ""})
			  }
		  }
		  
		  state.responses[action.qn].question = action.q;
		  state.responses[action.qn].response = action.a;
		
		  var complete = true;
		  for (var i = 0; i < 7; i++) 
		  { 
			  if(state.responses[i].response === "")
			  {
				  complete = false;
				  break;
			  }
		  }
		  if(complete)
		  {
			  state.is_filled_out = true;
		  }
	})
	.addCase(createAction(ADD_SURVEY_RESPONSE_TEXT), (state, action) => {
         if(state.responses == null)
		  {
			  state.responses = [];
			  let i;
			  for (i = 0; i < 7; i++) //TODO make 7 dynamic
			  { 
				  state.responses.push({question: "", response: "", comment: ""})
			  }
		  }
		  
		  state.responses[action.qn].comment = action.text;
	})
	.addCase(createAction(ADD_SURVEY_STARS), (state, action) => {
        state.stars = action.stars;
	})
	.addCase(createAction(SET_SURVEY_TAKEN), (state, action) => {
        ReactGA.event({
			category: 'User',
			action: 'Survey Submitted'
		});
	  
	  	state.taken = action.bool;
	})

  })

export default survey;

